import { RequestService, type RequestOptions } from '../request-service';
import {
  BackOfficeHostingPlatforms,
  type AddHostListingPackageRequest,
  type AddHostListingPackageResponse,
  type QueryHostListingsRequest,
  type QueryHostListingsResponse,
} from '@wix/ambassador-os-backoffice-v1-host-listing/types';
import type RpcModule from '@wix/ambassador-os-backoffice-v1-host-listing/rpc';
import type HttpModule from '@wix/ambassador-os-backoffice-v1-host-listing/http';
import { HostListings } from './host-listings';

type RpcModuleType = typeof RpcModule;
type HttpModuleType = typeof HttpModule;

export class HostListingsService extends RequestService<
  RpcModuleType,
  HttpModuleType
> {
  protected async rpcModule(): Promise<RpcModuleType> {
    return import('@wix/ambassador-os-backoffice-v1-host-listing/rpc');
  }

  protected async httpModule(): Promise<HttpModuleType> {
    return import('@wix/ambassador-os-backoffice-v1-host-listing/http');
  }

  public async getHostListings(
    hostType: BackOfficeHostingPlatforms = BackOfficeHostingPlatforms.BUSINESS_MANAGER,
    options?: RequestOptions,
  ): Promise<HostListings> {
    const response = await this.request<
      QueryHostListingsRequest,
      QueryHostListingsResponse
    >({
      methodName: 'queryHostListings',
      payload: { query: { filter: { hostType } } },
      options,
    });

    return new HostListings(response);
  }

  public async addPackage(
    packageId: string,
    options?: RequestOptions,
  ): Promise<void> {
    await this.request<
      AddHostListingPackageRequest,
      AddHostListingPackageResponse
    >({
      methodName: 'addHostListingPackage',
      payload: {
        hostType: BackOfficeHostingPlatforms.BUSINESS_MANAGER,
        packageId,
      },
      options,
    });
  }
}
